import React from 'react';
import { motion } from 'framer-motion';
import { goToCheckout } from '../lib/checkout';
export function FooterCta() {
  const scrollToPricing = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-primary text-white" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-101">
            🏋️ STRETCHING 360 — El sistema de planificación N°1 para
            instructores de stretching argentinos.
          </h2>

          <p className="text-xl md:text-2xl mb-12 text-white/90 italic" data-id="element-102">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>

          <div className="mb-8" data-id="element-103">
            <p className="text-2xl font-bold mb-6" data-id="element-104">
              ¿Seguís improvisando el lunes a la mañana?
            </p>
            <p className="text-xl mb-2" data-id="element-105">👇</p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-106">
            <div className="bg-white/10 rounded-lg p-6 border border-white/20" data-id="element-107">
              <p className="text-lg font-semibold mb-2" data-id="element-108">
                📘 PACK PROFESIONAL → $18.990
              </p>
              <p className="text-sm text-white/80" data-id="element-109">12 Tomos + 6 Bonus</p>
            </div>

            <div className="bg-highlight/20 rounded-lg p-6 border-2 border-highlight" data-id="element-110">
              <p className="text-lg font-semibold mb-2" data-id="element-111">
                🏆 MEGAPACK ÉLITE → $27.990
              </p>
              <p className="text-sm text-white/80 mb-1" data-id="element-112">
                12 Tomos + 6 Bonus + 2 Ebooks Élite
              </p>
              <p className="text-xs text-highlight font-bold" data-id="element-113">⭐ MÁS ELEGIDO</p>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => goToCheckout('elite')} className="bg-highlight text-primary px-12 py-5 rounded-lg font-bold text-xl mb-8 hover:bg-highlight-dark transition-colors shadow-2xl" data-id="element-114">
            SÍ, QUIERO EL MEGAPACK ÉLITE →
          </motion.button>

          <div className="text-sm text-white/80 space-y-1 mb-12" data-id="element-115">
            <p data-id="element-116">Pago seguro · Acceso en 5 min</p>
            <p data-id="element-117">Garantía 7 días sin preguntas</p>
            <p data-id="element-118">Tarjeta · Débito · Transferencia</p>
          </div>

          <div className="border-t border-white/20 pt-8" data-id="element-119">
            <p className="text-2xl font-bold mb-4" data-id="element-120">🏋️ STRETCHING 360™</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm mb-4" data-id="element-121">
              <a href="mailto:contacto@stretching360.com.ar" className="hover:text-highlight transition-colors" data-id="element-122">
                📧 contacto@stretching360.com.ar
              </a>
              <span data-id="element-123">|</span>
              <a href="#" className="hover:text-highlight transition-colors" data-id="element-124">
                📲 @stretching360.ar
              </a>
              <span data-id="element-125">|</span>
              <a href="#" className="hover:text-highlight transition-colors" data-id="element-126">
                🌐 www.stretching360.ar
              </a>
            </div>
            <p className="text-xs text-white/60" data-id="element-127">
              © STRETCHING 360™ 2026 — Todos los derechos reservados.
            </p>
            <p className="text-xs text-white/60 mt-2" data-id="element-128">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}